/** Zeilen-Kontexte, die die Vorschau-Karte darstellen kann (Stundenplan wie Epochenplan). */
export type PreviewSectionContext = 'classes' | 'teachers' | 'rooms';

/**
 * Automatik-Ansicht der Vorschau-Karte: Hat man eine Karte in der Hand, zeigt die Vorschau nicht
 * einen, sondern mehrere Abschnitte untereinander – nämlich die Ressourcen, die man beim Stecken im
 * jeweiligen Board-Kontext NICHT sieht (im Klassen-Board fehlen Lehrende und Räume usw.).
 *
 * `subjects` bekommt kein eigenes Layout: die Vorschau kennt nur Klassen/Lehrende/Räume als Zeilen.
 */
export function previewMapSections(boardContext: string): PreviewSectionContext[] {
  switch (boardContext) {
    case 'rooms':
      return ['classes', 'teachers', 'rooms'];
    case 'teachers':
      return ['classes', 'rooms'];
    default:
      return ['teachers', 'rooms'];
  }
}
